<img src="content/images/icons/pencil-square.svg" width="20" height="20">
